import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  fetchDayByDayAnalytics,
  clearDayByDayAnalytics,
} from 'redux/analytics/actions';

import { Loader } from 'semantic-ui-react';
import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';
import AnalyticsPlaceholder from 'components/dashboard/analytics-content/AnalyticsPlaceholder';
import ChartItem from 'components/dashboard/analytics-content/AnalyticsActivityCharts/ChartItem';
// import ChartBarItem from 'components/dashboard/analytics-content/AnalyticsActivityCharts/ChartBarItem';

import './AnalyticsActivityCharts.css';

const AnalyticsActivityCharts = ({
  date,
  fetchDayByDayAnalytics,
  clearDayByDayAnalytics,
  analyticsByDay,
  analyticsByDayError,
  analyticsTotal,
}) => {
  const { t } = useTranslation();
  const chartOptions = {
    views: {
      type: 'views',
      color: '0, 204, 98',
      text: t("Views"),
    },

    visitors: {
      type: 'visitors',
      color: '240, 11, 95',
      text: t("Unique Visitors"),
    },

    clicks: {
      type: 'clicks',
      color: '57, 58, 167',
      text: t("Clicks"),
    },

    ctr: {
      type: 'ctr',
      color: '41, 117, 207',
      text: 'CTR',
      labelPrefix: '%',
    },
  };

  useEffect(() => {
    fetchDayByDayAnalytics(date);
    return () => clearDayByDayAnalytics();
  }, [date]);

  const [byDayData, setByDayData] = useState(null);
  const checkChartParams = analyticsByDay &&
    Object.keys(analyticsByDay).map(i => analyticsByDay[i] && Object.keys(analyticsByDay[i])).filter(i => i.length > 0).length === 0;

  useEffect(() => {
    let array = [];
    let res = null;
    if (analyticsByDay && Object.keys(analyticsByDay).length > 0) {
      Object.keys(analyticsByDay).map(i => {
        Object.keys(analyticsByDay[i]).forEach(item => {
          if (!array.includes(item)) {
            array.push(item);
          }
        });
      });

      if (array && array.length > 0) {
        res = Object.keys(analyticsByDay).reduce((obj, chartItem) => ({
          ...obj,
          [chartItem]: array.sort().map(paramItem => ({
            date: paramItem,
            value: analyticsByDay[chartItem][paramItem] ? analyticsByDay[chartItem][paramItem] : 0,
          }))
        }), {});
      }
    }
    setByDayData(res);
  }, [analyticsByDay]);

  if (analyticsByDayError) {
    return null;
  }

  if (checkChartParams) {
    return <AnalyticsPlaceholder title={t("Link Performance by Date")} text={t("Looks like you have no data to display yet…")} />;
  }

  const renderData = () => {
    if (!byDayData || !analyticsByDay) {
      return null;
    }
    return (
      <>
        {byDayData && Object.keys(analyticsByDay).map(i => (
          <ChartItem
            key={`analytics_activity_chart_item_id_${i}`}
            chartData={byDayData[i]}
            color={chartOptions[i].color}
            header={chartOptions[i].text}
            type={chartOptions[i].type}
            labelPrefix={chartOptions[i].labelPrefix || ''}
            totalData={analyticsTotal ? analyticsTotal[i] : null}
          />
        ))}
      </>
    );
  };

  return (
    <AnalyticsSection
      header={
        <div className="title">
          <h3>{t("Link Performance by Date")}</h3>
        </div>
      }
      className="analytics-activity-charts__component"
    >
      <div className="analytics-activity-charts-wrapper">
        {renderData()}
        <Loader active={!byDayData} />
      </div>

    </AnalyticsSection>
  );
};

AnalyticsActivityCharts.propTypes = {
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.node]),
  analyticsByDay: PropTypes.oneOfType([PropTypes.object]),
  analyticsByDayError: PropTypes.oneOfType([PropTypes.object]),
  analyticsTotal: PropTypes.oneOfType([PropTypes.object]),
  fetchDayByDayAnalytics: PropTypes.func,
  clearDayByDayAnalytics: PropTypes.func,
  chartData: PropTypes.oneOfType([PropTypes.object]),
};
AnalyticsActivityCharts.defaultProps = {
  date: null,
  analyticsByDay: null,
  analyticsByDayError: null,
  analyticsTotal: null,
  fetchDayByDayAnalytics: null,
  clearDayByDayAnalytics: null,
  chartData: null,
};

const mapStateToProps = state => ({
  analyticsByDay: state.analyticsReducer.analyticsByDay,
  analyticsByDayError: state.analyticsReducer.analyticsByDayError,
  analyticsTotal: state.analyticsReducer.analyticsTotal,
});

export default connect(
  mapStateToProps,
  {
    fetchDayByDayAnalytics,
    clearDayByDayAnalytics,
  },
)(AnalyticsActivityCharts);
